/**
 * 任务管理器单例类
 */
class TaskManager {
    constructor() {
        if (TaskManager.instance) {
            return TaskManager.instance;
        }
        this.tasks = {};
        TaskManager.instance = this;
    }

    addTask(taskId, taskInfo) {
        this.tasks[taskId] = taskInfo;
    }

    getTask(taskId) {
        return this.tasks[taskId];
    }

    removeTask(taskId) {
        if (this.tasks[taskId]) {
            delete this.tasks[taskId];
            return true;
        }
        return false;
    }

    getAllTasks() {
        const tasks = [];
        for (const taskId in this.tasks) {
            if (this.tasks.hasOwnProperty(taskId)) {
                const task = this.tasks[taskId];
                tasks.push({
                    taskId: taskId,
                    fileName: task.file ? task.file.name : '',
                    fileSize: task.file ? task.file.size : 0,
                    startTime: task.startTime,
                    type: 'multipart',
                });
            }
        }
        return tasks;
    }

    cancelTask(taskId) {
        const task = this.getTask(taskId);
        if (task && task.uploader) {
            task.uploader.cancel();
            return true;
        }
        return false;
    }
}

module.exports = TaskManager;